const femaleGenital=
[
{symptom:"vaginalDischarge",
displayAs:"Unexplained Vaginal Discharge",
questionGroup: "vaginalDischarge"
},

{symptom:"pmBleeding",
displayAs:"Post menopausal bleeding",
questionGroup: "vaginalBleeding"
},

{symptom:"abnCervix",
displayAs: "Cervix exam consistent with cancer",
questionGroup: "description"
},

{symptom: "vulvalLump",
displayAs: "Vulval lump, ulceration or bleeding",
questionGroup: "vulval"},

{symptom: "vaginalMass",
displayAs: "Vaginal Mass",
questionGroup: "vulval"},
]

export default femaleGenital